<!-- Loader affiché tant que la formation n'est pas encore disponible -->
<div class="assign-loading" *ngIf="!formation" [ngClass]="{'assign-modal-wrapper': openInModal}">
    <span class="loader-wheel-blue"></span>
    <span class="loading-message">loading exercices</span>
</div>

<div id="assign-sheets" *ngIf="formation" [ngClass]="{'assign-modal-wrapper': openInModal}">
    <div class="assign-header">
        <i id="back-report-button" class="material-icons back-btn" (click)="goBack()">arrow_back</i>
        <span class="page-title" translate>Assign Exercises</span>
        <span class="class-ref">for {{ formation.student.user.first_name }}'s training</span>
    </div>

    @if (formation && formation.percent_exercice_rate > 0) {
    <div class="title-exercice"><span translate>Total assigned exercises at this stage of the training</span></div>
    <app-progress-gauge [formation]="formation" [extraShouldBeAssigned]="extraShouldBeAssigned"></app-progress-gauge>
    }

    <!-- Filtres affichés dynamiquement -->
    <div class="filter-container">
        <div class="filter-header">
            <div class="filter-item">
                <label for="level">Title:</label>
                <input id="search" type="text" class="filter-input" placeholder="" [(ngModel)]="searchTerm"
                    (ngModelChange)="searchSubject.next(searchTerm)">
            </div>

            <button class="assign-filter-btn" (click)="showFilterMenu = !showFilterMenu">
                <span translate>Other filters</span>
                <mat-icon>{{ showFilterMenu ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>

        </div>

        <div class="filter-group">
            @if (showFilterMenu) {
            @if (typeExercice === 'onsite') {
            <div class="filter-item">
                <label for="level">Level:</label>
                <select id="level" class="filter-select" [(ngModel)]="selectedLevel"
                    (ngModelChange)="loadExercises(typeCategory)">
                    <option *ngFor="let level of levels" [value]="level.value">{{ level.label }}</option>
                </select>
            </div>
            <div class="filter-item">
                <label for="validated">Status:</label>
                <select id="validated" class="filter-select" [(ngModel)]="validatedFilter"
                    (ngModelChange)="loadExercises(typeCategory)">
                    <option value="completed">Completed</option>
                    <option value="uncompleted">Not Validated</option>
                </select>
            </div>
            }
            @if (typeExercice === 'offsite') {
            <div class="filter-item">
                <label for="level">Difficulty:</label>
                <select id="level" class="filter-select" [(ngModel)]="selectedDifficulty"
                    (ngModelChange)="getAvailableExercice(typeCategory)">
                    <option *ngFor="let difficulty of difficulties" [value]="difficulty.data">{{ difficulty.label }}
                    </option>
                </select>
            </div>
            }
            }
        </div>
    </div>

    @if (typeExercice === 'onsite') {
    <!-- Tableau des fiches -->
    <div class="table-container">
        <table class="exercise-table">
            <thead>
                <tr>
                    <th></th>
                    <th>Sheet Name</th>
                    <th>Preview Sheet</th>
                    <th>Exercises</th>
                </tr>
            </thead>
            <tbody>
                @for (sheet of sheets; track sheet.id) {
                <tr>
                    <td>
                        <div class="sheet-icon-validate-container">
                            <span class="sheet-icon-validate" [ngClass]="{
                                      'sheet-validated': sheet.is_validate_by_student
                                  }">
                            </span>
                        </div>
                    </td>
                    <td
                        [innerHTML]="exerciceSheetService.getContentValueByTypeContent('title', sheet.content) || 'N/A'">
                    </td>
                    <td>
                        <button class="default-btn" (click)="togglePreview(sheet.id, 'sheet')">
                            View
                            <mat-icon class="icon">{{ isPreviewVisible(sheet.id) ? 'expand_less' : 'expand_more'
                                }}</mat-icon>
                        </button>
                    </td>
                    <td>
                        <button class="default-btn" (click)="toggleExercises(sheet.id)">
                            Show
                            <mat-icon class="icon">{{ isExercisesVisible(sheet.id) ? 'expand_less' : 'expand_more'
                                }}</mat-icon>
                        </button>
                    </td>
                </tr>

                <!-- Preview with Scroll -->
                @if (isPreviewVisible(sheet.id)) {
                <tr>
                    <td colspan="4">
                        <div class="preview-container">
                            <div class="sheet-viewer-body">
                                <div id="explain-block-mobile" #explainblockmobile class="sheet-viewer-subblock">
                                    <div class="sheet-viewer-media" *ngIf="sheet.media?.media_type=='image'">
                                        <img class="sheet-viewer-img" src="{{ sheet.media.url }}" />
                                    </div>
                                    <div class="sheet-viewer-media" *ngIf="sheet.media?.media_type=='video'">
                                        <div class="sheet-viewer-vid">
                                            <youtube-player videoId="{{ sheet.media.url }}" suggestedQuality="highres"
                                                [width]="400"></youtube-player>
                                        </div>
                                    </div>
                                    <div class="sheet-viewer-content" [innerHTML]="content">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                }

                <!-- Liste des exercices -->
                @if (isExercisesVisible(sheet.id)) {
                <tr>
                    <td colspan="4">
                        @if (isSheetExercisesLoading(sheet.id)) {
                        <div class="exercises-loading">
                            <span class="loader-wheel-blue"></span>
                            <span class="loading-message" translate>Loading exercises...</span>
                        </div>
                        } @else {
                        <table class="exercise-list-table">
                            <thead>
                                <tr>
                                    <th>Level</th>
                                    <th>Duration (min)</th>
                                    <th>Preview</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (exercise of getExercises(sheet.id); track exercise.id) {
                                <tr>
                                    <td class="capitalize">{{ exercise.difficulty }}</td>
                                    <td>{{ exercise.duration }}</td>
                                    <td>
                                        <button class="default-btn" (click)="toggleExercisePreview(exercise.id)" [disabled]="isExerciseQuestionsLoading(exercise.id)">
                                            <span class="loader-wheel-blue" *ngIf="isExerciseQuestionsLoading(exercise.id)"></span>
                                            <span>View</span>
                                            <mat-icon class="icon" *ngIf="!isExerciseQuestionsLoading(exercise.id)">{{ isExercisePreviewVisible(exercise.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
                                        </button>
                                    </td>
                                    <td>
                                        @if (exercise.is_validate_by_student) {
                                        <button class="validated-btn">
                                            Done
                                        </button>
                                        } @else if (exercise.is_todo_by_student) {
                                        <button class="unassign-btn" (click)="unassignExercise(exercise, sheet.id)" [disabled]="isExerciseLoading(exercise.id) || !canUnassign(exercise)" [matTooltip]="!canUnassign(exercise) ? 'Cannot unassign: would go below required' : ''" [matTooltipDisabled]="canUnassign(exercise)">
                                            <span class="loader-wheel" *ngIf="isExerciseLoading(exercise.id)"></span>
                                            <span class="btn-label">Unassign</span>
                                        </button>
                                        }
                                        @else {
                                        <button class="assign-btn" (click)="assignExercise(exercise, sheet.id)" [disabled]="isExerciseLoading(exercise.id)">
                                            <span class="loader-wheel" *ngIf="isExerciseLoading(exercise.id)"></span>
                                            <span class="btn-label">Assign</span>
                                        </button>
                                        }
                                    </td>
                                </tr>

                                <!-- Preview de l'exercice avec ses questions -->
                                @if (isExercisePreviewVisible(exercise.id)) {
                                <tr>
                                    <td colspan="4">
                                        @if (isExerciseQuestionsLoading(exercise.id)) {
                                        <div class="questions-loading">
                                            <span class="loader-wheel-blue"></span>
                                            <span class="loading-message" translate>Loading questions...</span>
                                        </div>
                                        } @else if (getExerciseDetails(exercise.id)) {
                                        <app-exercice-preview [exercice]="getExerciseDetails(exercise.id)"></app-exercice-preview>
                                        }
                                    </td>
                                </tr>
                                }
                                }
                            </tbody>
                        </table>
                <tr *ngIf="exercisesMap.has(sheet.id) && exercisesMap.get(sheet.id).next">
                    <td colspan="4" class="load-more-container">
                        <button class="default-btn" (click)="loadMoreExercices(sheet.id)" [disabled]="isSheetExercisesLoading(sheet.id)">
                            <span class="loader-wheel-blue" *ngIf="isSheetExercisesLoading(sheet.id)"></span>
                            <span translate>Load more exercices</span>
                        </button>
                    </td>
                </tr>
                        }
                    </td>
                </tr>
                }
                }
            </tbody>
            <tr *ngIf="next">
                <td colspan="5" class="load-more-container">
                    <button class="default-btn" (click)="loadMore()">
                        <span translate>Load More</span>
                    </button>
                </td>
            </tr>
        </table>
    </div>
    }

    @if (typeExercice === 'offsite') {
    <!-- Bouton pour créer un exercice -->
    <div class="create-exercise-container">
        <button (click)="isCreating = !isCreating" class="default-btn">
            <span translate>Create Exercice</span>
            <mat-icon>{{ isCreating ? 'expand_less' : 'add' }}</mat-icon>
        </button>
    </div>

    <!-- Formulaire de création d'exercice -->
    @if (isCreating) {
    <app-create-exercice-offsite [language]="formation.language" (exerciceCreated)="reloadList()">
    </app-create-exercice-offsite>
    }

    <!-- Tableau des exercices -->
    <div class="table-container">
        <table class="exercise-offsite-table">
            <thead>
                <tr>
                    <th>Title</th>
                    <th>Difficulty</th>
                    <th>Duration (min)</th>
                    <th>Preview</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                @for (exercise of exerciceList; track exercise.id) {
                <tr>
                    <td>{{ exercise.title }}</td>
                    <td class="capitalize">{{ exercise.difficulty }}</td>
                    <td>{{ exercise.duration }}</td>
                    <td>
                        <button class="default-btn" (click)="togglePreview(exercise.id, 'exercice')">
                            View
                            <mat-icon>{{ isPreviewVisible(exercise.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </button>
                    </td>
                    <td>
                        @if (exercise.is_validate_by_student) {
                        <button class="validated-btn">
                            Done
                        </button>
                        } @else if (exercise.is_todo_by_student) {
                        <button class="unassign-btn" (click)="unassignExercise(exercise)" [disabled]="isExerciseLoading(exercise.id) || !canUnassign(exercise)" [matTooltip]="!canUnassign(exercise) ? 'Cannot unassign: would go below required' : ''" [matTooltipDisabled]="canUnassign(exercise)">
                            <span class="loader-wheel" *ngIf="isExerciseLoading(exercise.id)"></span>
                            <span class="btn-label">Unassign</span>
                        </button>
                        }
                        @else {
                        <button class="assign-btn" (click)="assignExercise(exercise)" [disabled]="isExerciseLoading(exercise.id)">
                            <span class="loader-wheel" *ngIf="isExerciseLoading(exercise.id)"></span>
                            <span class="btn-label">Assign</span>
                        </button>
                        }
                    </td>
                </tr>

                <!-- Accordéon pour la preview -->
                @if (isPreviewVisible(exercise.id)) {
                <tr>
                    <td colspan="5">
                        <div class="preview-container">
                            <app-exercice-view [exercice]="exercise" [isEditMode]="true" (exerciceUpdated)="updateOffsiteExerciseInList($event)"></app-exercice-view>
                        </div>
                    </td>
                </tr>
                }
                }
            </tbody>
            <tr *ngIf="next">
                <td colspan="5" class="load-more-container">
                    <button class="default-btn" (click)="loadMore()">
                        <span translate>Load More</span>
                    </button>
                </td>
            </tr>
        </table>
    </div>
    }
</div>